import React, { useEffect } from "react";

const eng_graph_2 = {
  width: 400,
  height: 420.08,
  viewBox: "0 0 400 420.079833984375",
  pattern: {
    id: "bar4",
    patternUnits: "userSpaceOnUse",
    width: 10,
    height: 100,
    patternTransform: "rotate(50)",
    x: 0,
    y: 0,
    // 패턴은 더 이상 사용하지 않지만, 디자인 요소로 남겨둡니다.
    rects: [
      { x: 0, y: 0, width: 5, height: 100, fill: "#CDCDCD" },
      { x: 5, y: 0, width: 5, height: 100, fill: "#444444" },
    ],
  },
  yAxis: {
    ticks: [
      { position: 48, label: "35" },
      { position: 76.57142857142857, label: "30" },
      { position: 105.14285714285714, label: "25" },
      { position: 133.71428571428572, label: "20" },
      { position: 162.28571428571428, label: "15" },
      { position: 190.85714285714286, label: "10" },
      { position: 219.42857142857144, label: "5" },
      { position: 248, label: "0" },
    ],
    axisLabel: ["Rainfall", "(cm per week)"],
    axisLine: { x: 106.8125, y1: 48, y2: 248 },
  },
  title: "Rainfall in Five Regions",
  bars: [
    { region: "School A", x: 132.10227272727272, y: 219, width: 25.289772727272727, height: 29 },
    { region: "School B", x: 182.68181818181816, y: 133, width: 25.289772727272727, height: 115 },
    { region: "School C", x: 233.2613636363636, y: 190, width: 25.289772727272727, height: 58 },
    { region: "School D", x: 283.84090909090907, y: 57, width: 25.289772727272727, height: 191 },
    { region: "School E", x: 334.42045454545456, y: 133, width: 25.289772727272727, height: 115 },
  ],
  legend: {
    box: { x: 194.97659301757812, y: 382.23974609375, width: 101.85931396484375, height: 26.84 },
    items: [{ color: "#B3B3B3", label: "school" }],
  },
};

const Set_eng_graph_2 = ({ graphData }) => {
  // graphData가 없으면 기본 데이터 사용
  const {
    width,
    height,
    viewBox,
    // pattern은 여전히 남겨두지만, 막대 fill에는 사용하지 않습니다.
    pattern,
    yAxis,
    title,
    bars,
    legend,
  } = graphData || eng_graph_2;

  // 패턴 정의는 그대로 둡니다.
  const renderDefs = () => (
    <defs>
      <pattern
        id={pattern.id}
        patternUnits={pattern.patternUnits}
        width={pattern.width}
        height={pattern.height}
        patternTransform={pattern.patternTransform}
        x={pattern.x}
        y={pattern.y}
      >
        {pattern.rects.map((rect, idx) => (
          <rect
            key={idx}
            x={rect.x}
            y={rect.y}
            width={rect.width}
            height={rect.height}
            fill={rect.fill}
          />
        ))}
      </pattern>
    </defs>
  );

  // y축 렌더링 (눈금, 레이블, 2줄짜리 축 라벨)
  const renderYAxis = () => (
    <g>
      {yAxis.ticks.map((tick, idx) => (
        <g key={`ytick-${idx}`}>
          <line
            x1="106.8125"
            y1={tick.position}
            x2="385"
            y2={tick.position}
            stroke="#000"
            strokeWidth="0.9"
          />
          <line
            x1="100.8125"
            y1={tick.position}
            x2="112.8125"
            y2={tick.position}
            stroke="#000"
            strokeWidth="0.9"
          />
          <text
            transform={`translate(94.8125,${tick.position + 6})`}
            textAnchor="end"
            fontSize="19.84"
          >
            {tick.label}
          </text>
        </g>
      ))}
      <g transform="translate(24,148) rotate(-90)">
        <text x="0" y="0" textAnchor="middle" fontSize="19.84">
          {yAxis.axisLabel[0]}
        </text>
        <text x="0" y="24" textAnchor="middle" fontSize="19.84">
          {yAxis.axisLabel[1]}
        </text>
      </g>
      <line
        x1={yAxis.axisLine.x}
        y1={yAxis.axisLine.y1}
        x2={yAxis.axisLine.x}
        y2={yAxis.axisLine.y2}
        stroke="#000"
        strokeWidth="0.9"
      />
    </g>
  );

  // 차트 제목 렌더링
  const renderTitle = () => (
    <text x="245.90625" y="24" textAnchor="middle" fontSize="19.84">
      {title}
    </text>
  );

  // 막대와 막대 레이블 렌더링
  // fill은 고정된 솔리드 컬러 "#B3B3B3"로 설정하고, 텍스트 위치를 y좌표 +15로 조정
  const renderBars = () => (
    <g>
      {bars.map((bar, idx) => (
        <g key={`bar-${idx}`}>
          <rect
            x={bar.x}
            y={bar.y}
            width={bar.width}
            height={bar.height}
            fill="#B3B3B3"
            stroke="#000"
            strokeWidth="0.9"
          />
          <text
            transform={`translate(${bar.x + bar.width + 10}, ${bar.y + bar.height + 15}) rotate(-40)`}
            textAnchor="end"
            fontSize="19.84"
          >
            {bar.region}
          </text>
        </g>
      ))}
    </g>
  );

  // 범례 렌더링
  const renderLegend = () => (
    <g>
      <rect
        x={legend.box.x}
        y={legend.box.y}
        width={legend.box.width}
        height={legend.box.height}
        fill="none"
        stroke="#000"
        strokeWidth="0.9"
      />
      {legend.items.map((item, idx) => (
        <g key={`legend-item-${idx}`}>
          <rect
            x={legend.box.x + 6}
            y={legend.box.y + 6 + idx * 20}
            width="12"
            height="12"
            fill={item.color}
            stroke="#000"
            strokeWidth="0.9"
          />
          <text
            x={legend.box.x + 26}
            y={legend.box.y + 6 + idx * 20 + 12}
            fontSize="19.84"
          >
            {item.label}
          </text>
        </g>
      ))}
    </g>
  );

  return (
    <svg width={width} height={height} viewBox={viewBox} xmlns="http://www.w3.org/2000/svg">
      {renderDefs()}
      <g>
        {renderYAxis()}
        {renderTitle()}
        {renderBars()}
        {renderLegend()}
      </g>
    </svg>
  );
};

export { eng_graph_2, Set_eng_graph_2 };
